import { render, staticRenderFns } from "./recharges.vue?vue&type=template&id=1967f021&scoped=true&"
import script from "./recharges.vue?vue&type=script&lang=js&"
export * from "./recharges.vue?vue&type=script&lang=js&"
import style0 from "./recharges.vue?vue&type=style&index=0&id=1967f021&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967f021",
  null
  
)

export default component.exports